import React, { useCallback, useEffect, useState } from 'react';
import api, { errMsg } from '../services/api';
import { fmt } from '../services/format';
import Msg from '../components/Msg';
import Pager from '../components/Pager';

const FILTERS = [
  { id: 'pending', label: 'În așteptare' },
  { id: 'all', label: 'Toate' },
  { id: 'aprobat', label: 'Aprobate' },
  { id: 'respins', label: 'Respinse' },
];
const LABEL = { pending: 'în așteptare', aprobat: 'aprobată', respins: 'respinsă' };
const SIZE = 20;

export default function Requests() {
  const [status, setStatus] = useState('pending');
  const [page, setPage] = useState(0);
  const [data, setData] = useState(null);
  const [notes, setNotes] = useState({});
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await api.get('/api/requests', { params: { status, page, size: SIZE } });
      setData(r.data);
    } catch (e) {
      setMsg({ type: 'err', text: errMsg(e) });
    }
  }, [status, page]);

  useEffect(() => { load(); }, [load]);

  const act = async (id, action) => {
    setBusy(true); setMsg(null);
    try {
      await api.post(`/api/requests/${id}/${action}`, { note: notes[id] || '' });
      setMsg({ type: 'ok', text: action === 'approve' ? 'Cererea a fost aprobată, limita familiei a fost mărită.' : 'Cererea a fost respinsă.' });
      await load();
    } catch (e) {
      setMsg({ type: 'err', text: errMsg(e) });
      await load();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <h2>Cereri de mărire a limitei</h2>
      <div className="toolbar">
        {FILTERS.map(f => (
          <button key={f.id} className={`btn btn-small${status === f.id ? ' btn-primary' : ''}`}
            onClick={() => { setStatus(f.id); setPage(0); setData(null); }}>{f.label}</button>
        ))}
      </div>
      <Msg msg={msg} />
      {!data && <p className="muted">Se încarcă…</p>}
      {data && data.items.length === 0 && <p className="muted">Nicio cerere.</p>}
      {data && data.items.map(r => (
        <div key={r.requestId} className="card">
          <div className="card-row">
            <div>
              <b>{r.familyName}</b> cere <b>{r.requestedMax}</b> membri <span className="muted">(acum {r.currentMax})</span>
              <div className="muted small">
                {r.requesterName ? `${r.requesterName} · ${r.requesterEmail}` : 'cont șters'} · {fmt(r.createdAt)}
              </div>
              {r.message && <div className="quote">{r.message}</div>}
            </div>
            <span className={`badge badge-${r.status}`}>{LABEL[r.status] || r.status}</span>
          </div>
          {r.status === 'pending' ? (
            <div className="row-form">
              <input placeholder="Notă pentru admin (opțional)" maxLength={500} value={notes[r.requestId] || ''}
                onChange={e => setNotes({ ...notes, [r.requestId]: e.target.value })} />
              <button className="btn btn-primary" disabled={busy} onClick={() => act(r.requestId, 'approve')}>Aprobă</button>
              <button className="btn btn-danger" disabled={busy} onClick={() => act(r.requestId, 'reject')}>Respinge</button>
            </div>
          ) : (
            <div className="muted small">Rezolvată {fmt(r.answeredAt)}{r.adminNote ? ` · notă: ${r.adminNote}` : ''}</div>
          )}
        </div>
      ))}
      {data && <Pager page={data.page} size={data.size} total={data.total} onPage={setPage} />}
    </div>
  );
}
